import React from 'react';

import soehneBuch from '../assets/fonts/Soehne/Sohne-Buch.woff2';
import soehneBuchKursiv from '../assets/fonts/Soehne/Sohne-BuchKursiv.woff2';
import soehneHalbfett from '../assets/fonts/Soehne/Sohne-Halbfett.woff2';
import soehneHalbfettKursiv from '../assets/fonts/Soehne/Sohne-HalbfettKursiv.woff2';

import soehneMonoBuch from '../assets/fonts/Soehne/SohneMono-Buch.woff2';
import soehneMonoHalbfett from '../assets/fonts/Soehne/SohneMono-Halbfett.woff2';

import soehneIkon from '../assets/fonts/Soehne/SohneIkon-Buch.woff2';

import martinaPlantijnRegular from '../assets/fonts/MartinaPlantijn/martina-plantijn-web-regular.woff2';
import martinaPlantijnItalic from '../assets/fonts/MartinaPlantijn/martina-plantijn-web-italic.woff2';
import martinaPlantijnBold from '../assets/fonts/MartinaPlantijn/martina-plantijn-web-bold.woff2';
import martinaPlantijnBoldItalic from '../assets/fonts/MartinaPlantijn/martina-plantijn-web-bold-italic.woff2';

import calibre2Regular from '../assets/fonts/Calibre2/calibre2-regular.woff2';

import { FONT_FAMILY } from '../settings/Global';
import FontFace, { Font } from './FontFace';

const globalFonts: Font[] = [
    {
        fontFamily: FONT_FAMILY.SOEHNE,
        fontWeight: 'normal',
        fontStyle: 'normal',
        woff2Url: soehneBuch,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE,
        fontWeight: 'normal',
        fontStyle: 'italic',
        woff2Url: soehneBuchKursiv,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE,
        fontWeight: 'bold',
        fontStyle: 'normal',
        woff2Url: soehneHalbfett,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE,
        fontWeight: 'bold',
        fontStyle: 'italic',
        woff2Url: soehneHalbfettKursiv,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE_MONO,
        fontWeight: 'normal',
        fontStyle: 'normal',
        woff2Url: soehneMonoBuch,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE_MONO,
        fontWeight: 'bold',
        fontStyle: 'normal',
        woff2Url: soehneMonoHalbfett,
    },
    {
        fontFamily: FONT_FAMILY.SOEHNE_IKON,
        fontWeight: 'normal',
        fontStyle: 'normal',
        woff2Url: soehneIkon,
    },
    {
        fontFamily: FONT_FAMILY.MARTINA_PLANTIJN,
        fontWeight: 'normal',
        fontStyle: 'normal',
        woff2Url: martinaPlantijnRegular,
    },
    {
        fontFamily: FONT_FAMILY.MARTINA_PLANTIJN,
        fontWeight: 'normal',
        fontStyle: 'italic',
        woff2Url: martinaPlantijnItalic,
    },
    {
        fontFamily: FONT_FAMILY.MARTINA_PLANTIJN,
        fontWeight: 'bold',
        fontStyle: 'normal',
        woff2Url: martinaPlantijnBold,
    },
    {
        fontFamily: FONT_FAMILY.MARTINA_PLANTIJN,
        fontWeight: 'bold',
        fontStyle: 'italic',
        woff2Url: martinaPlantijnBoldItalic,
    },
    {
        fontFamily: FONT_FAMILY.CALIBRE2,
        fontWeight: 'normal',
        fontStyle: 'normal',
        woff2Url: calibre2Regular,
    },
];

function GlobalFonts(): React.ReactElement {
    return (
        <>
            {/*
            Preload the main font of the site.
            See https://www.zachleat.com/web/preload/
            for some light reading on this subject.
            */}
            <link
                rel="preload"
                href={soehneBuch}
                as="font"
                type="font/woff2"
                crossOrigin="anonymous"
            />
            <FontFace fonts={globalFonts} />
        </>
    );
}

export default React.memo(GlobalFonts);
